import React, { useEffect, useState } from 'react';
import {
    Box, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText, Divider
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import BaseHeader from '../BaseHeader';
import HelpButton from '../HelpButton';
import TagSearchSelect from '../TagSearchSelect';
import ErrorDialog from '../../dialogs/ErrorDialog';
import { canCreateOwnerRoom, getOwnerRoomCreateDeniedMessage } from '../../../common/ownerRoomPermission';

function RankHeader({ user }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [ownerCreateDeniedDialogVisible, setOwnerCreateDeniedDialogVisible] = useState(false);
    const ticketBalance = user ? (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            <AirplaneTicketIcon sx={{ fontSize: 16 }} />
            <span>参加チケット {user.ticket}枚</span>
        </Box>
    ) : '';

    const linkBoxSx = {
        cursor: 'pointer',
        borderRadius: '3px',
        padding: '8px',
        transition: 'background-color 0.2s ease, color 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
        },
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.24)',
        },
        '&:focus-visible': {
            outline: '2px solid #ffffff',
            outlineOffset: '2px',
        },
    };

    const drawerLinkSx = {
        padding: '8px 16px',
        width: '100%',
        cursor: 'pointer',
        borderRadius: '4px',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        '&:active': {
            backgroundColor: 'rgba(0, 0, 0, 0.16)',
        },
        '&:focus-visible': {
            outline: '2px solid #000000',
            outlineOffset: '2px',
        },
    };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1100);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigate = (path) => {
        window.location.href = path;
    };

    const openOwnerCreatePage = () => {
        if (user && !canCreateOwnerRoom(user)) {
            setOwnerCreateDeniedDialogVisible(true);
            return;
        }

        navigate('./owner');
    };

    const openOwnerCreatePageFromDrawer = () => {
        setDrawerOpen(false);
        openOwnerCreatePage();
    };

    const drawerContents = (
    <Box sx={{ width: 250 }} role="presentation" onClick={() => setDrawerOpen(false)}>
        <List>
        <Divider />
        <ListItem disablePadding>
            <ListItemButton>
                <Box
                    onClick={() => navigate('./mypage')}
                    sx={drawerLinkSx}
                >
                    <ListItemText
                        primary={user.name}
                        secondary={ticketBalance}
                    />
                </Box>
            </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
            <ListItemButton>
                <Box
                    onClick={openOwnerCreatePageFromDrawer}
                    sx={drawerLinkSx}
                >
                    <ListItemText primary="ベットルームの作成" />
                </Box>
            </ListItemButton>
        </ListItem>
        </List>
    </Box>
    );


    return (
        <>
            <BaseHeader>
                {isMobile ? (
                    <>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: 0 }}>
                            <Box onClick={() => navigate('./')} sx={linkBoxSx}>TOP</Box>
                            <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                                <TagSearchSelect />
                                <HelpButton />
                                <IconButton
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={() => setDrawerOpen(true)}
                                    sx={{ flexShrink: 0 }}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Box>
                        </Box>
                        <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                            {drawerContents}
                        </Drawer>
                    </>
                ) : (
                    <>
                        <Box onClick={() => navigate('./')} sx={{ ...linkBoxSx, width: '40px' }}>TOP</Box>
                        <Box onClick={openOwnerCreatePage} sx={{ ...linkBoxSx, width: '180px' }}>ベットルームの作成</Box>
                        <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                            <TagSearchSelect />
                            <HelpButton />
                            <Box onClick={() => navigate('./mypage')} sx={{ ...linkBoxSx, width: '160px', padding: '6px 8px' }}>
                                <div>{user.name}</div>
                                <div>{ticketBalance}</div>
                            </Box>
                        </Box>
                    </>
                )}
            </BaseHeader>
            <ErrorDialog
                isVisible={ownerCreateDeniedDialogVisible}
                onClose={() => setOwnerCreateDeniedDialogVisible(false)}
                message={getOwnerRoomCreateDeniedMessage(user)}
            />
        </>
    );
}

export default RankHeader;
